import Link from 'next/link';
import { useMemo } from 'react';
import Styles from './index.module.scss';
import { ArrowLeft, ArrowRight } from '@/components/SvgIcon/icons/Arrows';
import { useRouter } from 'next/router';

interface IDocProps {
  docId: string;
  docName: string;
}

interface IProps {
  currentDocId: string;
  docList: IDocProps[];
}

/**
 * 上一篇文章、下一篇文章 切换的快捷键
 */
const ArticleChangeTool = ({ currentDocId, docList }: IProps) => {
  const router = useRouter();
  const currentDocIdIndex: number = useMemo(() => {
    return docList.findIndex((doc) => {
      return doc.docId === currentDocId;
    });
  }, [currentDocId, docList]);
  if (currentDocIdIndex === -1) {
    return <></>;
  }

  const DocCom = (props: {
    data?: IDocProps;
    text: string;
    iconType: 'left' | 'right';
  }) => {
    const Text = () => {
      return <span>{props.text}</span>;
    };

    return (
      <span>
        {props.data ? (
          <Link
            href={`/document/${router.query.productCode}/${props.data.docId}`}
            passHref
          >
            <span className={Styles.docCom}>
              {props.iconType === 'left' && <ArrowLeft />}
              <Text />
              {props.data.docName}
              {props.iconType === 'right' && <ArrowRight />}
            </span>
          </Link>
        ) : (
          <span>
            <Text />-
          </span>
        )}
      </span>
    );
  };

  return (
    <div className={Styles.container}>
      <DocCom
        data={docList[currentDocIdIndex - 1]}
        text="上一篇："
        iconType="left"
      />
      <DocCom
        data={docList[currentDocIdIndex + 1]}
        text="下一篇："
        iconType="right"
      />
    </div>
  );
};

export default ArticleChangeTool;
